import { render } from "./HotelForm.vue?vue&type=template&id=132ef339&scoped=true"
import script from "./HotelForm.vue?vue&type=script&lang=js"
export * from "./HotelForm.vue?vue&type=script&lang=js"

import "./HotelForm.vue?vue&type=style&index=0&id=132ef339&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-132ef339"

export default script